import React, { useState, useEffect, useRef } from 'react';
import '../component.scss';
import SearchField from './SearchField';
import SearchDropdownMultiselectOpenList from './SearchDropdownMultiselectOpenList';
import SearchDropdownVirtualizedList from './SearchDropdownVirtualizedList';
import {
  beautyReefHotelList,
  noWindHotelList,
} from '../../widgets/SearchTourForm/constants/EgypetCollectionHotelsList';
import { MdFilterAlt } from 'react-icons/md';
import HOTEL_RATING_MAP from '../../widgets/SearchTourForm/constants/HatelRatingMap';
import HasReviews from '../../widgets/SearchTourForm/components/HasReviews';
import {
  RiCheckboxBlankCircleLine,
  RiCheckboxCircleLine,
} from 'react-icons/ri';

const SearchHotelsWidget = ({
  label,
  title = '',
  items,
  value,
  hasFilter = false,
  buttonReset = false,
  buttonDone = true,
  onReset,
  cssClass = '',
  width = 220,
  country,
  recomend,
  rating = '',
  onChooseCollection,
  onChoose,
  onSetRating,
  onRecomend,
  placeholder = true,
  dictionary = {},
  hasReviews,
  onSetWithReviews,
  hotelsIdWithReviews,
  recomendList,
  setWidgetOpened,
  isWidgetOpened,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isHotelsCollection, setIsHotelsCollection] = useState(false);
  const [isRecomend, setIsRecomend] = useState(recomend);
  const [ratingValue, setRatingValue] = useState(rating);
  const [hotelsCollection, setHotelsCollection] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [wasChanged, setWasChanged] = useState(!!value.length);
  const [isWithReviews, setWithReviews] = useState(hasReviews);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleClickOutside);
    };
  }, []);

  const hotelsCollectionOptions = [
    {
      id: 2,
      name: 'Отели без ветра зимой',
      recomend: false,
    },
    {
      id: 3,
      name: 'Отели с красивым рифом',
      recomend: false,
    },
  ];

  const setValue = (val) => {
    onChoose(val);
    setWasChanged(val.length ? true : false);
  };

  const setCollectionValue = (value) => {
    let newCollection = [...hotelsCollection];
    if (hotelsCollection.includes(value)) {
      let index = newCollection.indexOf(value);
      newCollection.splice(index, 1);
    } else {
      newCollection.push(value);
    }
    setHotelsCollection(newCollection);
    let hotelsIdsValuesList = [];

    if (newCollection.includes(2)) {
      hotelsIdsValuesList = [...hotelsIdsValuesList, ...noWindHotelList];
    }
    if (newCollection.includes(3)) {
      hotelsIdsValuesList = [...hotelsIdsValuesList, ...beautyReefHotelList];
    }
    onChooseCollection(hotelsIdsValuesList);

    setWasChanged(value.length ? true : false);
  };

  const setHotelRating = (value) => {
    setRatingValue(value);
    onSetRating(value);
  };

  const reset = () => {
    setSearchTerm('');
    setFilteredOptions([]);
    setHotelsCollection([]);
    onReset();
    setHotelRating(0);
    setWasChanged(false);
    onRecomend(false);
    setIsRecomend(false);
    onSetWithReviews(false);
    setWithReviews(false);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    const filtered = items.filter((option) =>
      option.name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredOptions(filtered);
  };

  const toggleHotelsCollection = (e) => {
    setIsHotelsCollection(!isHotelsCollection);
    onReset();
    setSearchTerm('');
    setFilteredOptions([]);
    setHotelsCollection([]);
    setWasChanged(false);
  };

  function handleRecomend() {
    reset();
    onRecomend(!isRecomend);
    setIsRecomend(!isRecomend);
  }

  function handleWithReviews() {
    reset();
    onSetWithReviews(!isWithReviews);
    setWithReviews(!isWithReviews);
  }

  let items_fix = items;
  let title_fix = title;
  if (filteredOptions.length) {
    items_fix = filteredOptions;
  }

  if (isHotelsCollection) {
    items_fix = hotelsCollectionOptions;
  }
  if (hotelsCollection.length) {
    if (hotelsCollection.includes(2) && hotelsCollection.includes(3)) {
      title_fix = 'Отели с красивым рифом и без ветра';
    } else if (hotelsCollection.includes(3)) {
      title_fix = 'Отели с красивым рифом';
    } else if (hotelsCollection.includes(2)) {
      title_fix = 'Отели с бухтой без ветра';
    }
  }

  return (
    <div ref={dropdownRef} className={`search-widget ${cssClass}`}>
      {!isOpen ? (
        <div
          onClick={() => {
            setIsOpen(!isOpen);
            setWidgetOpened(true);
          }}
          className={`search-field ${wasChanged}`}
        >
          <SearchField
            cssClass={cssClass}
            placeholder={placeholder}
            label={label}
            title={title_fix}
            value={value}
            dictionary={dictionary}
          />
        </div>
      ) : (
        <>
          <SearchField
            label={label}
            title={title}
            value={value}
            dictionary={dictionary}
          />
          <div className="popup-list">
            {buttonDone || buttonReset ? (
              <div className="filterbar">
                {buttonDone && (
                  <button
                    className="btn btn_submit"
                    onClick={() => setIsOpen(false)}
                  >
                    Готово
                  </button>
                )}
                {buttonReset && (
                  <button className="btn btn_reset" onClick={reset}>
                    Сбросить
                  </button>
                )}
              </div>
            ) : (
              ''
            )}
            {hasFilter || country === 1 ? (
              <div className="filterinput">
                {hasFilter && (
                  <input
                    type="text"
                    placeholder={label}
                    autoFocus
                    value={searchTerm}
                    onChange={handleInputChange}
                  />
                )}
                {country === 1 && (
                  <span
                    className={`filter-button ${isHotelsCollection}`}
                    onClick={toggleHotelsCollection}
                  >
                    <MdFilterAlt />
                  </span>
                )}
              </div>
            ) : (
              ''
            )}
            <div className="subwidget">
              {isWidgetOpened && recomendList ? (
                <button
                  className={`hotels__reviews-filter${
                    isRecomend ? ' hotels__reviews-filter_active' : ''
                  }`}
                  onClick={handleRecomend}
                  title="Отфильтровать рекомендуемые нами отели"
                >
                  <span>Рекомендуемые отели</span>
                  {isRecomend ? (
                    <RiCheckboxCircleLine />
                  ) : (
                    <RiCheckboxBlankCircleLine />
                  )}
                </button>
              ) : null}
              {isWidgetOpened && hotelsIdWithReviews ? (
                <HasReviews
                  hasReviews={isWithReviews}
                  onFilter={handleWithReviews}
                />
              ) : null}
              <select
                onChange={(e) => setHotelRating(e.target.value)}
                value={ratingValue}
              >
                {HOTEL_RATING_MAP.map((rating) => (
                  <option key={rating.id} value={rating.id}>
                    {rating.name}
                  </option>
                ))}
              </select>
            </div>
            {isWidgetOpened && items_fix.length > 0 ? (
              isHotelsCollection ? (
                <SearchDropdownMultiselectOpenList
                  value={hotelsCollection}
                  items={hotelsCollectionOptions}
                  onChoose={setCollectionValue}
                />
              ) : (
                <SearchDropdownVirtualizedList
                  value={value}
                  items={items_fix}
                  onChoose={setValue}
                />
              )
            ) : (
              <img
                src="https://www.geograftour.com/static/index/img/geoclient-loader.gif"
                style={{
                  margin: '50px auto',
                  display: 'block',
                  height: '50px',
                }}
                alt={'Идет загрузка'}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchHotelsWidget;
